import { ReactElement, memo } from 'react';

import { ErrorAlert, Spinner } from '@/common/components';
import { QueryError } from '@/common/interfaces';

interface Props<T> {
  isLoading: boolean;
  isError: boolean;
  error: QueryError | null;
  data?: T;
  children: (data: NonNullable<T> | never) => ReactElement;
}
const genericMemo: <T>(component: T) => T = memo;

function FallbackedLayoutComponent<T>({ children, isLoading, isError, error, data }: Props<T>): ReactElement {
  if (isLoading) {
    return <Spinner />;
  } else if (isError) {
    return error?.response?.status === 498 ? <Spinner /> : <ErrorAlert error={error} />;
  } else {
    return data ? children(data) : children(undefined as never);
  }
}

export const FallbackedLayout = genericMemo(FallbackedLayoutComponent);
